import { DictionaryItem } from 'types/Dictionary';

export const getCopy = (key: string, dict?: DictionaryItem[]): string =>
  dict?.filter((item: any) => item.key === key)[0]?.value || `MISSING TRANSLATION: "${key}"`;
